<template>
  <header>
    <app-logo/>
  </header>
</template>

<script>
import AppLogo from "./AppLogo.vue";

export default {
  components: {
    AppLogo
  }
};
</script>

<style lang="scss" scoped>
</style>